import React from "react";
import CardWrapper from "../CardWrapper";
import styles from "../AccordionRow/Accordion.module.css";
import skeletonStyles from "./Skeletons.module.css";

const NoteSkeleton: React.FC<{ count?: number }> = ({ count = 1 }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <CardWrapper key={index} customClass={styles.noteWrapper}>
          <div className={styles.noteHeader}>
            <div className="flex gap-1">
              <div
                className={skeletonStyles.skeleton}
                style={{ width: "10rem", height: "2rem" }}
              ></div>
              <div
                className={skeletonStyles.skeleton}
                style={{ width: "8rem", height: "2rem" }}
              ></div>
            </div>
          </div>
          <div className={styles.noteValue}>
            <div
              className={skeletonStyles.skeleton}
              style={{ width: "100%", height: "1.6rem", marginBottom: "0.8rem" }}
            ></div>
            <div
              className={skeletonStyles.skeleton}
              style={{ width: "90%", height: "1.6rem", marginBottom: "0.8rem" }}
            ></div>
            <div
              className={skeletonStyles.skeleton}
              style={{ width: "80%", height: "1.6rem" }}
            ></div>
          </div>
        </CardWrapper>
      ))}
    </>
  );
};

export default NoteSkeleton;
